import * as React from "react";

// components
import TitleSeparator from "./titleSeparator";
import Bullet from "./_partials/_bullet";
import ButtonLink from "./_partials/_buttonLink";

class BulletsSection extends React.Component {
  render() {
    const { info, centeredPage } = this.props;

    return (
      <div className={"bulletsSectionContent position-relative pt-4 pt-sm-4 pt-md-0 d-table-cell " + (info.noPadding ? "" : "px-4")}>
        <TitleSeparator info={info} centeredPage={centeredPage}></TitleSeparator>
        <div className={(info.customPBText ? "pb-30" : "pb-100") + " " + (info.itemsClass ? info.itemsClass : "")}>
          {info.item &&
            info.item.text.map((col, i) => (
              <Bullet
                centeredPage={centeredPage}
                icon={info.icon}
                text={col}
                url={info.item.url ? info.item.url[i] : ""}
                colorClass={info.item.colorClass}
                noSpacing={info.item.noSpacing ? info.item.noSpacing : false}
                key={i}
              ></Bullet>
            ))}
        </div>
        {info.cta && (
          <div className={"pt-40 pb-3 text-center bottom-0 position-absolute w-100 " + (info.cta.parentClass ? info.cta.parentClass : "")}>
            <ButtonLink text={info.cta.text} url={info.cta.url} type={info.cta.type} extraClass={info.cta.extraClass}></ButtonLink>
          </div>
        )}
      </div>
    );
  }
}

export default BulletsSection;
